import type { Errors } from "./useDraft";
import { useDraft } from "./useDraft";
import { useSave, type SaveOptions } from "./useSave";

/** 草稿到写入体的换算：换算失败时 body 为空，errors 是字段错误。 */
export type Convert<D, In> = (draft: D) => { body?: In; errors: Errors<D> };

/** 主数据的新建与编辑表单：草稿、字段错误、提交时换算并保存。三个页面的抽屉都用它组装。 */
export function useEntityForm<D extends object, In, Out>(initial: D, convert: Convert<D, In>, save: (body: In) => Promise<Out>, opts: SaveOptions<Out>) {
  const form = useDraft(initial);
  const m = useSave(save, opts);
  const submit = () => {
    const { body, errors } = convert(form.draft);
    form.setErrors(errors);
    if (body) m.save(body);
  };
  return { draft: form.draft, set: form.set, errors: form.errors, submit, saving: m.saving, error: m.error, warning: m.warning };
}
